import {FormControlLabel, Radio, RadioGroup, RadioGroupProps} from '@mui/material';
import {FormControl} from '@mui/material';
import React from 'react';

export type AppRadioProps = RadioGroupProps & {
    options: {value: string; label: string; key?: string}[];
};

export const AppRadio: React.FC<AppRadioProps> = ({id, options, ...rest}) => {
    return (
        <FormControl>
            <RadioGroup row aria-label="color" {...rest}>
                {options.map(radio => (
                    <FormControlLabel
                        key={radio.key}
                        value={radio.value}
                        control={<Radio color="primary" sx={{color: 'primary.main'}} />}
                        label={radio.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default AppRadio;
